import React from "react";
import CarouselClass from "./CarouselClass";
import VideoList from "./VideoList";
import Footer from "../footer/Footer";
import NavbarClass from "../NavbarClass";
import { connect } from "react-redux";
import { fetchVideos, videoWatched } from "../../actions/videoActions";
import "./VideoPage.css";
import { pageview } from "../../utils/googleAnalyticsUtils";
class VideoPage extends React.Component {
  async componentDidMount() {
    pageview('Videos');
    await this.props.fetchVideos(this.props.userStatus.isPremium);
    this.handleVideosLoaded();
  }

  state = { loggedIn: false, showVideo: false, videosLoaded: false };

  renderVideo() {
    return (
      <div>
        <div
          className="btn-close ms-auto btn-lg"
          style={{
            marginRight: "10px",
            display: `${this.state.showVideoModal ? null : "none"}`,
          }}
          onClick={() => this.setState({ showVideoModal: false })}
        ></div>
        {/* <iframe
          src="https://player.vimeo.com/video/568050039?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          width="100%"
          // height=""
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullscreen
          title="EPISOD 8 HD 1080 ORIGINAL"
        ></iframe> */}

        <div
          style={{
            padding: "56.25% 0 0 0",
            position: "relative",
            height: "100%",
            width: "100%",
            overflow: "hidden",
          }}
        >
          <iframe
            src="https://player.vimeo.com/video/568062912?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
            }}
            title="Ep8_combine"
          ></iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
    );
  }

  handleVideosLoaded = () => {
    this.setState({ videosLoaded: true });
  };

  render() {
    return (
      <div>
        {this.state.showVideo ? (
          this.renderVideo()
        ) : (
          <div
            className="video-page-container"
            style={this.state.videosLoaded ? {} : { display: "none" }}
          >
            <div className="video-page-content-container">
              <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />
              <CarouselClass />
              <div style={{ minHeight: "500px" }}>
                {this.props.videos && (
                  <VideoList
                    videos={this.props.videos}
                    videosCount={this.props.videosCount}
                    searchEnabled
                  />
                )}
              </div>
            </div>
            <Footer />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    videos: state.videos.videos?.videos,
    loading: state.videos.loading,
    videosCount: state.videos.videos.videosCount,
    videoLink: state.videos?.videoLink,
    userStatus: state.userLoggedinAndPremiumCheck,

    // userData: state.checkUser.userData,
    // type: state.type,
  };
};

export default connect(mapStateToProps, {
  fetchVideos,
  videoWatched,
})(VideoPage);
